import React, { createContext, useState, useEffect } from "react";
import { getCourses, getCategories } from "./CourseAPI";

export const CourseContext = createContext<any>([]);

const CourseProvider: React.FC<{ children: any }> = ({ children }) => {
  const [courses, setCourses] = useState<any>([]);
  const [categories, setCategories] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    Promise.all([getCourses(), getCategories()]).then((res) => {
      setCourses(res[0]);
      setCategories(res[1]);
      setLoading(false);
      console.log(res);
    });
  }, []);

  return (
    <CourseContext.Provider
      value={[
        courses,
        setCourses,
        loading,
        setLoading,
        categories,
        setCategories,
      ]}
    >
      {children}
    </CourseContext.Provider>
  );
};

export default CourseProvider;
